import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits
   * Cart buttons are always managed client-side, never server-disabled
   */
  updateButtonStates() {
    const { minusButton, plusButton, quantityInput } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();
    const disableMinus = value <= min;
    const disablePlus = effectiveMax !== null && value >= effectiveMax;

    // Disabling a focused button can drop keyboard focus to the document body.
    // Move to this selector's input first, without stealing focus from elsewhere.
    const activeElement = document.activeElement;
    if (
      !quantityInput.disabled &&
      ((activeElement === minusButton && disableMinus) || (activeElement === plusButton && disablePlus))
    ) {
      quantityInput.focus({ preventScroll: true });
    }

    // Cart buttons are always dynamically managed
    minusButton.disabled = disableMinus;
    plusButton.disabled = disablePlus;
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
